module.exports = require("./xog-UG.js");